import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Home from "./screens/home";
import VSUIncident from "./screens/vsuincident";
import VSUIncidentBreif from "./screens/vsuincident-breif";
import PWAPrompt from "react-ios-pwa-prompt2";
import PreviewPage from "./screens/preview";
import PWAInstaller from "./controller/pwainstaller";
import TermsAndConditions from "./screens/terms-and-conditions";

// 👉 NEW: GTM
import TagManager from "react-gtm-module";

const GTM_ID = "GTM-PJ7PZ3"; // process.env.REACT_APP_GTM_ID`;

// Initialize GTM once, as early as possible
if (GTM_ID) {
  TagManager.initialize({
    gtmId: GTM_ID,
    // optional: seed your dataLayer with app-level info
    dataLayer: {
      appName: "VSU App",
      appEnv: process.env.NODE_ENV,
    },
    // dataLayerName: "dataLayer", // if you use a custom name
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));

const handleKeyEnter = (e) => {
  if (e?.key === "Enter") {
    const ignoredField = ["textarea", "button"];
    if (!ignoredField.includes(e?.target?.localName)) {
      e.preventDefault();
    }
  }
};
document.addEventListener("keydown", handleKeyEnter);

// 👉 NEW: push a virtual pageview on route changes
function GTMRouteListener() {
  const location = useLocation();
  const lastPathRef = React.useRef("");

  React.useEffect(() => {
    const path = location.pathname + location.search + location.hash;

    // Avoid double-push in React 18 StrictMode dev re-renders
    if (path === lastPathRef.current) return;
    lastPathRef.current = path;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "pageview",
      pagePath: path,
      pageTitle: document.title,
    });
  }, [location]);

  return null;
}

root.render(
  <React.StrictMode>
    <BrowserRouter>
      {/* Push pageview on first load + every route change */}
      <GTMRouteListener />

      <Routes>
        <Route index element={<Home />} />
        <Route path="vsu-incident-report" element={<VSUIncident />} />
        <Route path="vsu-incident-report/:id" element={<VSUIncident />} />
        <Route path="vsu-incident-report-breif/" element={<VSUIncidentBreif />} />
        <Route path="vsu-incident-report-breif/:id" element={<VSUIncidentBreif />} />
        <Route path="vsu-incident-report-preview" element={<PreviewPage />} />
        <Route path="terms-and-conditions" element={<TermsAndConditions />} />
      </Routes>
    </BrowserRouter>

    <PWAInstaller />
    <PWAPrompt />
  </React.StrictMode>
);

serviceWorkerRegistration.register();
reportWebVitals();
